import React, { useRef, useState } from 'react';
import { QrReader } from "react-qr-reader";
import { ThreeDot } from "react-loading-indicators";
import Header from '../components/Header';
import Button from '../components/Button';
import Input from '../components/Input';
import Handler from '../services';
import MyText from '../components/MyText';
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import { useAuth } from '../context/AuthContext';
import AppVersion from '../components/AppVersion';

export default function Search() {
    const { userInfo } = useAuth();
    const [pending, setPending] = useState(false);
    const [numConto, setNumConto] = useState("");
    const [microchip, setMicrochip] = useState("");
    // const [selectedClient, setSelectedClient] = useState(null);
    // const [selectedPet, setSelectedPet] = useState(null);
    const scannedRef = useRef(false);
    const [selected] = useState("environment")
    const [qrReaderVisible, setQReaderVisible] = useState(false);
    const [petScan, setpetScan] = useState(null);
    const handler = Handler();
    const navigate = useNavigate();

    const handleScan = async (scanData) => {
        if (scanData && scanData !== "" && !scannedRef.current) {
            setPending(true);
            scannedRef.current = true;
            let decodedTextList = scanData.text.split(';');
            let petRes = await handler.getPetById(decodedTextList[0]);
            let myPet = { "id": petRes.id, "label": petRes.name }
            // setSelectedPet(myPet);
            let clientRes = await handler.getClientById(decodedTextList[1]);
            let myClient = {
                "id": clientRes.id,
                "label": clientRes.firstname + " " + clientRes.lastname,
                "email": clientRes.email,
                "amount": clientRes.associations.wallet[0].pet_penny
            }
            // setSelectedClient(myClient);
            setQReaderVisible(false);
            setPending(false);
            scannedRef.current = false;
            navigate('/RegistraAcquisto', { state: { pet: myPet, client: myClient } });
        }
    };

    const handleScanPacchetto = async (scanData) => {
        if (scanData && scanData !== "" && !scannedRef.current && qrReaderVisible) {
            setPending(true);
            scannedRef.current = true;
            let decodedTextList, idOrdine, idRiga, idProdotto, cat;
            try {
                decodedTextList = scanData.text.split(';');
                idOrdine = decodedTextList[0].split("idOrdine:")[1];
                idRiga = decodedTextList[1].split("idRiga:")[1];
                idProdotto = decodedTextList[3].split("idProdotto:")[1];
                cat = decodedTextList[4].split("cat:")[1];
            } catch (error) {
                console.log("Errore decodifica QR", error);
            }
            if(!idOrdine || !idRiga || !idProdotto || !cat){
                scannedRef.current = false;
                setQReaderVisible(false);
                setPending(false);
                toast.error('Codice QR non valido');
                return;
            }
            let pRes = await handler.getPacchetti(idProdotto);

            // check se pacchetto esclusivo partner
            if(pRes.id_partner !== '' && pRes.id_partner !== "0" && pRes.id_partner !== 0 && pRes.id_partner.toString() !== userInfo.nome_clinica){
                toast.error('Il pacchetto scansionato è esclusivo per un altro partner, non può essere attivato qui.');
                setQReaderVisible(false);
                setPending(false);
                scannedRef.current = false;
                return;
            }

            // check se pacchetto già attivato o rimborsato
            let oRes = await handler.getOrderRowById(idOrdine);
            if(oRes.usato || oRes.product_quantity_refunded === oRes.product_quantity){
                toast.error('Il pacchetto scansionato è già stato attivato o rimborsato e non può essere utilizzato.');
                setQReaderVisible(false);
                setPending(false);
                scannedRef.current = false;
                return;
            }

            let clientRes = await handler.getClientById(decodedTextList[2].split("idCliente:")[1]);
            let client = {
                "id": clientRes.id,
                "label": clientRes.firstname + " " + clientRes.lastname,
                "email": clientRes.email
            }
            setQReaderVisible(false);
            setPending(false);
            scannedRef.current = false;
            navigate('/RegistraPacchetto',
                {
                    state: {
                        idProdotto,
                        name: pRes.name, 
                        cat,
                        client,
                        idOrdine,
                        idRiga,
                        descrizione: pRes.description,
                        riepilogo: pRes.description_short,
                        importo: parseFloat(pRes.price),
                    }
                }
            );
        }
    };

    const handleSearch = async () => {
        if (numConto === "" && microchip === "") {
            toast.error('Inserisci almeno un parametro di ricerca!');
            return;
        }
        setPending(true);
        try {
            let res = await handler.getClientBySearch(numConto, microchip);
            let myPet = res && res.pet ? { "id": res.pet.id, "label": res.pet.name } : null;
            let myClient = res && res.client ? {
                "id": res.client.id_customer || res.client.id,
                "label": res.client.firstname + " " + res.client.lastname,
                "email": res.client.email,
                "amount": res.client.associations.wallet[0].pet_penny
            } : null;

            if (!myPet && !myClient) {
                throw new Error("Nessun risultato trovato.");
            }
            navigate('/RegistraAcquisto', { state: { pet: myPet, client: myClient } });
        } catch (err) {
            toast.error(err.message || 'Errore durante la ricerca.');
        } finally {
            setPending(false);
        }
    }

    const handleError = (error) => {
        console.log("ERRORE", error);
    };

    if (pending) {
        return (
            <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: '#f2f2f2' }}>
                <ThreeDot variant="bob" color="#e83465" size="large" text="Ricerca in corso..." textColor="#282d68" />
            </div>
        )
    }

    return (
        <div style={styles.container}>
            <Header />
            {qrReaderVisible ?
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', overflowY: 'hidden' }}>
                    <div style={{ width: "600px", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <QrReader
                            containerStyle={{ padding: 0, height: '100%', width: '100%' }}
                            constraints={{ facingMode: selected }}
                            delay={500}
                            onError={handleError}
                            onResult={petScan ? handleScan : handleScanPacchetto}
                            videoStyle={{ objectFit: 'contain', width: '100%' }}
                        />
                        <Button 
                            text="Chiudi" 
                            callback={() => setQReaderVisible(false)}
                            textStyle={styles.buttonTxt}
                        />
                    </div>
                </div>
                :
                <div>
                    <div style={styles.formSection}>
                        <div style={styles.inputCol}>
                            <Input
                                title="Numero Conto"
                                type="number"
                                nRows={1}
                                callback={(val) => setNumConto(val)}
                                width="100%"
                            />
                            <Input
                                title="Microchip"
                                // type="number"
                                nRows={1}
                                callback={(val) => setMicrochip(val)}
                                width="100%"
                            />
                            <div style={styles.buttonCol}>
                                <Button
                                    img={require("../assets/Contopet-IconaRicerca.png")}
                                    text="Ricerca"
                                    callback={handleSearch}
                                    containerStyle={styles.button}
                                    textStyle={styles.buttonTxt}
                                    imgStyle={styles.buttonImg}
                                />
                            </div>
                            {/* <div style={styles.oppureContainer}>
                                <div style={styles.line} />
                                <MyText style={styles.oppureText}>oppure</MyText>
                                <div style={styles.line} />
                            </div> */}
                            <div style={{ ...styles.buttonCol, marginTop: '2rem' }}>
                                <Button
                                    // img={qr}
                                    text="Scansiona QR del pet"
                                    callback={() => {
                                        setQReaderVisible(true)
                                        setpetScan(true)
                                    }}
                                    containerStyle={styles.button}
                                    textStyle={styles.buttonTxt}
                                    imgStyle={styles.buttonImg}
                                />
                            </div>
                            <div style={styles.oppureContainer}>
                                <div style={styles.line} />
                                <MyText style={styles.oppureText}>oppure</MyText>
                                <div style={styles.line} />
                            </div>
                            <div style={styles.buttonCol}>
                                <Button
                                    // img={qr}
                                    text="Registra QR Pacchetto di servizi"
                                    callback={() => {
                                        setQReaderVisible(true)
                                        setpetScan(false)
                                    }}
                                    containerStyle={styles.button}
                                    textStyle={styles.buttonTxt}
                                    imgStyle={styles.buttonImg}
                                />
                            </div>
                        </div>
                    </div>
                    <AppVersion />
                </div>
            }
        </div>);
}
const styles = {
    container: {
        height: '100%',
        flexDirection: 'column',
        backgroundColor: '#f2f2f2',
        overflowY: 'auto'
    },
    formSection: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: "1rem",
        marginBottom: "1rem",
    },
    inputCol: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: "400px",
        width: "100%",
        boxSizing: 'border-box',
        padding: "1rem",
    },
    buttonCol: {
        display: 'flex',
        // width: "35%",
        // flex: 1,
        justifyContent: "center",
        alignItems: "end",
        width: "100%",
        marginTop: "1rem",
    },
    button: {
        width: "100%",
        padding: "10px 4px",
    },
    buttonTxt: {
        fontSize: '1.2rem',
        fontFamily: 'Como-Bold',
        color: "white"
    },
    buttonImg: {
        marginRight: '10px',
        height: "1.2rem"
    },
    oppureContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        margin: "3rem 0 2rem 0",
    },
    oppureText: {
        fontSize: '1.2rem',
        color: '#666',
        margin: "0 1rem"
    },
    line: {
        flex: 1,
        height: 1,
        backgroundColor: '#999',
    }
}